import React from 'react';
import ReactDOM from 'react-dom';
import App from 'src/App';
import { reportWebVitals } from 'src/reportWebVitals';
import './i18n-config';

ReactDOM.render(<App />, document.getElementById('root'));

reportWebVitals();
